export default "__VITE_ASSET__58984cc9__"